var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompany(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 14 14",
    style: {
      enableBackground: "new 0 0 14 14"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#172242;stroke-width:0.9717;stroke-linecap:round;stroke-linejoin:round;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5,5.5c1.2,0,2.2-1,2.2-2.2C7.3,2,6.2,1,5,1C3.8,1,2.8,2,2.8,3.2C2.8,4.5,3.8,5.5,5,5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.5,13h-9v-1c0-1.2,0.5-2.3,1.3-3.2C2.7,8,3.8,7.5,5,7.5S7.3,8,8.2,8.8c0.8,0.8,1.3,2,1.3,3.2V13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9,1c0.6,0,1.2,0.2,1.6,0.7c0.4,0.4,0.7,1,0.7,1.6c0,0.6-0.2,1.2-0.7,1.6c-0.4,0.4-1,0.7-1.6,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.6,7.7c0.9,0.3,1.6,0.9,2.1,1.6c0.5,0.7,0.8,1.6,0.8,2.6V13H12"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.d5f20d43ff177fb92dbb96ea1ff794a9.svg";
export { ForwardRef as ReactComponent };